import React, {Component} from 'react';
import {connect} from 'react-redux';
import {_Object} from '../utils/utils';
import Svg from '../svg/index';
import {Theme} from '../theme/index';
import {animations} from './animations';
import {merge, extend} from './utilsFn';

class ButtonBox extends Theme {
    constructor(props) {
        super(props);
        let _state = {
            flag: 'def',
            styles: {},
            btn_tpye: "",
        };
        this.state = _Object.merge(this.state || {}, _state)
    };

    onMouseMoveFn = () => {
        this.setState({flag: 'move'});
    };
    onMouseLeaveFn = () => {
        this.setState({flag: 'def'});
    };
    handleFn = () => {
        this.setState({flag: 'cli'});
        this.props.handleBtn && this.props.handleBtn();
    };

    renderButtonType = (b_type, btnType) => {
        let color = btnType[b_type],
            radius = this.props.radius == undefined ? true : this.props.radius,
            shadow = this.props.shadow == undefined ? true : this.props.shadow;
        return {
            buttonBox: {
                width: this.props.width ? this.props.width : "5.625rem",
                height: this.props.height ? this.props.height : "2.1875rem",
                background: color.botton_bgcolor,
                position: "relative",
                borderRadius: this.props.radius ? "0.1875rem" : "0",
                display: "inline-block"
            },
            buttonCont: {
                width: "100%",
                height: "100%",
                color: color.cont_color,
                position: "relative",
                zIndex: "2",
                display: "flex",
                borderRadius: radius ? "0.1875rem" : "0",
                justifyContent: "center",
                alignItems: "center",
                verticalAlign: "middle",
                boxShadow: shadow ? "0 0 0.08rem 0 #888" : "",//0 0.08rem 0.25rem 0 #aeaeae
                cursor: "pointer",
                transform: "perspective(1) translateZ(0)",
                transitionProperty: "all",
                transitionDuration: "0.3s",
            },
            buttonCont_move: {
                color: color.cont_move_color,
                //boxShadow: shadow ? "0 0.08rem 0.4rem 0.08rem #ccc" : "",
            },
            buttonBackground: {
                width: "100%",
                height: "100%",
                position: "absolute",
                zIndex: "1",
                top: "0",
                bottom: "0",
                left: "0",
                right: "0",
                background: color.back_move_bgcolor,
                borderRadius: radius ? "0.3125rem" : "0",
                transitionProperty: "all",
                transitionDuration: "0.3s",
                transitionTimingFunction: "ease-out"
            },
            buttonBackground_move: {
                background: color.back_move_bgcolor,
            },
            buttonBackground_cli: {
                background: color.back_cli_bgcolor,
            }
        };
    };

    setStyle = (props) => {
        /*
         * btnSty 试列
         * {
         * cont_color:"",
         * cont_move_color:"",
         * botton_bgcolor:"",
         * back_move_bgcolor:"",
         * back_cli_bgcolor:"",
         * }
         * */

        let themeName =  props.theme || "default";
        let _theme = this.state.theme[themeName];

        let btn_sty = props.btnSty,//手动设置按钮几种状态的颜色
            btn_tpye = props.btnType || "default",
            amn_type = props.amnType || "h_l_u",// h_l_u h_c_o_u
            styles = {},
            btnType = Object.assign({}, _theme.button.buttonType);

        let scenesType = _theme.button.scenesType;

        const btn_sty_newFn = (sty) => {
            let btn_sty_new = {};
            btn_sty_new.cont_color = sty.cont_color || btnType.default.cont_color;
            btn_sty_new.cont_move_color = sty.cont_move_color || btnType.default.cont_move_color;
            btn_sty_new.botton_bgcolor = sty.botton_bgcolor || btnType.default.botton_bgcolor;
            btn_sty_new.back_move_bgcolor = sty.back_move_bgcolor || btnType.default.back_move_bgcolor;
            btn_sty_new.back_cli_bgcolor = sty.back_cli_bgcolor || btnType.default.back_cli_bgcolor;
            btnType.new = btn_sty_new;
        };

        if (props.scenesType) {
            btn_sty_newFn(scenesType[props.scenesType || "submit"]);
        }

        if (btn_sty) {
            btn_sty_newFn(btn_sty);
        }

        //只要设置 scenesType 场景类型 和 自定义样式  就用新的new  否则用默认的
        styles = this.renderButtonType(props.scenesType || btn_sty ? 'new' : btn_tpye, btnType);

        styles.buttonBackground = merge(styles.buttonBackground, animations[amn_type].def);
        styles.buttonBackground_move = merge(styles.buttonBackground_move, animations[amn_type].move);
        styles.buttonBackground_cli = merge(styles.buttonBackground_cli, animations[amn_type].cli);

        this.setState({styles: styles});
    };

    componentWillMount = () => {
        this.setStyle(this.props);
    };
    componentWillReceiveProps = (newProps) => {
        this.setStyle(newProps);
    };

    render() {
        let b_cont = this.state.styles.buttonCont,
            b_cont_move = this.state.styles.buttonCont_move,
            b_back = this.state.styles.buttonBackground,
            b_back_move = this.state.styles.buttonBackground_move,
            b_cli_move = this.state.styles.buttonBackground_cli,
            bCont = this.state.flag == 'def' ? b_cont : extend(b_cont, b_cont_move),
            bBack1 = b_back, bBack2 = b_back, fill;

        if (this.state.flag == 'def') {
            bBack1 = b_back;
            fill = this.state.styles.buttonCont.color;
        } else if (this.state.flag == 'move') {
            bBack1 = extend(b_back, b_back_move);
            fill = this.state.styles.buttonCont_move.color;
        } else if (this.state.flag == 'cli') {
            bBack2 = extend(b_back, b_cli_move);
            fill = this.state.styles.buttonCont_move.color;
        }
        return (
            <div style={this.state.styles.buttonBox} onClick={this.handleFn.bind(this)}>
                <div style={bBack1}></div>
                <div style={bBack2}></div>
                <div onMouseMove={this.onMouseMoveFn} onMouseLeave={this.onMouseLeaveFn} style={bCont}>
                    {this.props.svgName &&
                    <Svg type={this.props.svgName} fill={fill} width="1.25rem" height="1.25rem"
                         style={{marginRight: "0.5rem"}}/>
                    }
                    {this.props.btnText || "button"}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        theme: state.theme,
    }
};

const mapDispatchToProps = dispatch => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ButtonBox)